import { render } from "./CustomerOrders.vue?vue&type=template&id=e3164cfc"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script